import { ReactNode } from 'react';
import styles from './Modal.module.scss';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
  disableBackdropClose?: boolean;
}

function Modal({ isOpen, onClose, children, footer, className = '', disableBackdropClose = false }: ModalProps) {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={disableBackdropClose ? undefined : onClose}>
      <div className={`${styles.modal} ${className}`} onClick={(e) => e.stopPropagation()}>
        <div className={styles.body}>{children}</div>
        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </div>
  );
}

export default Modal;
